module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DModal', {
    attrs: {
      "isBgOverlay": true,
      "showClose": false
    }
  }, [_c('div', {
    staticClass: "insert brutto text-dark brutto-container",
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "brutto-container__header"
  }, [_c('h2', [_vm._v("Indsæt ressourceforbrug på flere")]), _vm._v(" "), _c('div', {
    staticClass: "icon__bg-circle doc-modal__close",
    on: {
      "click": _vm.close
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "brutto-container__body"
  }, [_c('div', {
    staticClass: "brutto-container__body__left"
  }, [_c('ul', {
    staticClass: "brutto__items"
  }, _vm._l((_vm.items), function(item, idx) {
    return _c('li', {
      key: item.id,
      staticClass: "brutto__items__item__container"
    }, [_c('div', {
      staticClass: "brutto__items__item"
    }, [_c('span', {
      staticClass: "norm-title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "d-input-group__input"
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v("Normalklasse")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.nHours),
        expression: "item.nHours"
      }],
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (item.nHours)
      },
      on: {
        "focus": function($event) {
          return $event.target.select()
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "nHours", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "d-input-group__input"
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v("Special klasse")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.sHours),
        expression: "item.sHours"
      }],
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (item.sHours)
      },
      on: {
        "focus": function($event) {
          return $event.target.select()
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "sHours", $event.target.value)
        }
      }
    })])])])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "brutto-container__footer"
  }, [_c('button', {
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("Annullér")]), _vm._v(" "), _c('button', {
    staticClass: "bttn bttn-primary",
    class: [{
      'bttn--loading': _vm.isSaving
    }],
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n        Gem\n      ")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-057f9bd4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Reporting/GrundskoleIndberetningRessourceInsertModal.vue
// module id = 1739
// module chunks = 1